<template>
  <div>
    <div v-if="!isMobileMenuOpen && !isResumeClinicOpen && !loginModalOpen" class="mob-bottom-nav">
      <template v-if="isLoggedIn">
        <div
          class="nav-item"
          @click="goToDashboard"
        >
          <div class="mob-avatar">
            <img v-if="userInfoData && userInfoData.image" :src="userInfoData.image" alt="Avatar" class="w-100 h-100 rounded-circle" style="object-fit: cover;" />
            <span v-else>{{ (userInfoData && userInfoData.username) ? (userInfoData.username).charAt(0).toUpperCase() : 'G' }}</span>
          </div>
          <span>Dashboard</span>
        </div>

        <div class="nav-separator"></div>

        <div
          class="nav-item"
          :class="{ active: notifOpen }"
          @click="toggleNotif"
        >
          <div class="nav-icon-container">
            <img
              v-if="notifOpen"
              src="../../assets/imgs/newMobNav/Bell_active.svg"
              alt="Notification"
            />
            <img
              v-else
              src="../../assets/imgs/newhomepage/bellweb.webp"
              alt="Notification"
            />
            <img src="../../assets/imgs/newMobNav/Login_Dot_inActive.svg" class="notif-dot" alt="" />
          </div>
          <span>Notification</span>
        </div>

        <div class="nav-separator"></div>

        <div
          class="nav-item"
          :class="{ active: showLogoutModal || externalLogoutOpen }"
          @click="triggerLogout()"
        >
          <img
            v-if="showLogoutModal || externalLogoutOpen"
            src="../../assets/imgs/newMobNav/LogOut_active.svg"
            alt="Log Out"
          />
          <img
            v-else
            src="../../assets/imgs/newMobNav/LogOut_inActive.svg"
            alt="Log Out"
          />
          <span>Log Out</span>
        </div>
      </template>

      <template v-else>

        <div
          class="nav-item"
          :class="{ active: notifOpen }"
          @click="toggleNotif"
        >
          <div class="nav-icon-container">
            <img
              v-if="notifOpen"
              src="../../assets/imgs/newMobNav/Bell_active.svg"
              alt="Notification"
            />
            <img
              v-else
              src="../../assets/imgs/newhomepage/bellweb.webp"
              alt="Notification"
            />
            <img src="../../assets/imgs/newMobNav/Login_Dot_inActive.svg" class="notif-dot" alt="" />
          </div>
          <span>Notification</span>
        </div>

        <div class="nav-separator"></div>

        <div
          class="nav-item"
          :class="{ active: isLoginActive }"
          @click="triggerLoginModal(isLoginActive)"
        >
          <img
            v-if="isLoginActive"
            src="../../assets/imgs/newMobNav/LogIn_active.svg"
            alt="Log In"
          />
          <img
            v-else
            src="../../assets/imgs/newMobNav/Login_inActive.svg"
            alt="Log In"
          />
          <span>Log In</span>
        </div>
      </template>
    </div>
    <LogoutConfirmModal
      :visible="showLogoutModal"
      @confirm="confirmLogout"
      @cancel="cancelLogout"
    />
  </div>
</template>

<script>
import LogoutConfirmModal from "@/components/modalComponent/LogoutConfirmModal.vue";
import EventBus from "@/utils/eventBus";
import { openLoginModal } from "@/utils/helpers";
import { mapGetters } from 'vuex';
import headerMixin from "@/utils/mixins/headerMixin";
export default {
  mixins: [headerMixin],
  data() {
    return {
      loginModalOpen: false,
      isMobileMenuOpen: false,
      activeHeaderType: null,
      showLogoutModal: false,
      externalLogoutOpen: false,
      isResumeClinicOpen: false,
      notifOpen: false,
      userDropdownOpen: false,
    };
  },
  components: {
    LogoutConfirmModal,
  },
  mounted() {
    this.onSetNotifOpen = (val) => {
      this.notifOpen = val;
    };
    EventBus.$on("set-notif-open", this.onSetNotifOpen);
    EventBus.$on("close-login-modal", () => {
      this.loginModalOpen = false;
    });
    EventBus.$on("open-login-modal", () => {
      this.loginModalOpen = true;
    });
    // Sync active state when any other component opens/closes logout modal
    this.onLogoutModalOpened = () => { this.externalLogoutOpen = true; };
    this.onLogoutModalClosed = () => { this.externalLogoutOpen = false; };
    EventBus.$on("logout-modal-opened", this.onLogoutModalOpened);
    EventBus.$on("logout-modal-closed", this.onLogoutModalClosed);
    if (this.$route.name === "NewHomePage") {
      this.activeHeaderType = "new";
    } else if (this.$route.name === "HomePage") {
      this.activeHeaderType = "legacy";
    }
    this.onMobileMenuState = (open) => {
      this.isMobileMenuOpen = !!open;
    };
    this.onActiveHeaderType = (type) => {
      this.activeHeaderType = type;
    };
    EventBus.$on("mobile-menu-state", this.onMobileMenuState);
    EventBus.$on("active-header-type", this.onActiveHeaderType);
    this.onResumeClinicOpened = () => { this.isResumeClinicOpen = true; };
    this.onResumeClinicClosed = () => { this.isResumeClinicOpen = false; };
    EventBus.$on("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$on("resume-clinic-closed", this.onResumeClinicClosed);
  },
  beforeDestroy() {
    EventBus.$off("set-notif-open", this.onSetNotifOpen);
    EventBus.$off("open-login-modal");
    EventBus.$off("mobile-menu-state", this.onMobileMenuState);
    EventBus.$off("active-header-type", this.onActiveHeaderType);
    EventBus.$off("logout-modal-opened", this.onLogoutModalOpened);
    EventBus.$off("logout-modal-closed", this.onLogoutModalClosed);
    EventBus.$off("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$off("resume-clinic-closed", this.onResumeClinicClosed);
  },
  watch: {},
  computed: {
    ...mapGetters({
      isLoggedIn: "userVUEX/getCandAccess",
      userData: "userVUEX/getUserProfileData",
    }),
    userInfoData() {
      return this.userData || {};
    },
    isLoginActive() {
      return (
        this.loginModalOpen ||
        this.$route.name === "Register" ||
        this.$route.path === "/register" ||
        this.$route.name === "Login" ||
        this.$route.path === "/login" ||
        this.$route.name === "ResumeBuilder" ||
        this.$route.path === "/resume_builder"
      );
    }
  },
  methods: {
    toggleNotif() {
      const nextOpen = !this.notifOpen;
      if (nextOpen) {
        EventBus.$emit("close-resume-clinic");
      }
      if (nextOpen && this.isLoginActive) {
        EventBus.$emit("close-login-modal");
      }

      if (nextOpen) {
        EventBus.$emit("close-header-search");
      }

      EventBus.$emit("set-notif-open", nextOpen);
    },
    triggerLoginModal(open) {
      if (open) {
        EventBus.$emit("close-login-modal");
        return;
      }else{
        if (this.isLoggedIn) {
          this.showLogoutModal = true;
        } else {
        EventBus.$emit("close-resume-clinic");
        EventBus.$emit("close-header-search");
        EventBus.$emit("close-mobile-menu");
        if (this.notifOpen) {
          EventBus.$emit("set-notif-open", false);
        }
        
        let inferredType = this.activeHeaderType;
        if (!inferredType) {
          if (document.querySelector(".mobHeader")) {
            inferredType = "legacy";
          } else if (document.querySelector(".new-header")) {
            inferredType = "new";
          }
        }
        if (inferredType === "legacy") {
          openLoginModal({userType : 'admin'})
        }else{
          openLoginModal()
        }
        this.loginModalOpen = true;
      }
      }
    },
    triggerLogout() {
      this.showLogoutModal = true;
    },
    async confirmLogout() {
      await this.$store.dispatch("userVUEX/LogOut");
      this.showLogoutModal = false;
      EventBus.$emit("close-resume-clinic");
      EventBus.$emit("close-header-search");
      EventBus.$emit("close-mobile-menu");
      if (this.notifOpen) {
        EventBus.$emit("set-notif-open", false);
      }
    },
    cancelLogout() {
      this.showLogoutModal = false;
    },
    async goToAdminHome() {
      EventBus.$emit("close-resume-clinic");
      EventBus.$emit("close-header-search");
      if (this.isLoginActive) {
        EventBus.$emit("close-login-modal");
        if (
          this.$route.name === "Register" ||
          this.$route.path === "/register" ||
          this.$route.name === "Login" ||
          this.$route.path === "/login"
        ) {
          return;
        }
      }
      if (this.notifOpen) {
        EventBus.$emit("set-notif-open", false);
      }
      let inferredHeaderType = this.activeHeaderType;
      if (!inferredHeaderType) {
        if (this.$route.name === "NewHomePage") {
          inferredHeaderType = "new";
        } else if (this.$route.name === "HomePage") {
          inferredHeaderType = "legacy";
        } else if (document.querySelector(".new-header")) {
          inferredHeaderType = "new";
        } else if (document.querySelector(".mobHeader")) {
          inferredHeaderType = "legacy";
        }
      }

      const targetHomeRoute =
        inferredHeaderType === "legacy" ? "HomePage" : "NewHomePage";

      if (this.$route.name === targetHomeRoute) {
        this.scrollToContainerOrWindow("home-container");
        return;
      }

      await this.pushAndScroll(
        {
          name: targetHomeRoute,
        },
        "home-container",
      );
    },
    scrollToContainerOrWindow(containerId) {
      const el = document.getElementById(containerId);
      const hasScrollableContainer = el && el.scrollHeight > el.clientHeight;

      if (hasScrollableContainer) {
        el.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    async pushAndScroll(targetRoute, containerId) {
      if (!this.isSameRoute(targetRoute)) {
        await this.$router.push(targetRoute);
      }

      this.$nextTick(() => {
        this.scrollToContainerOrWindow(containerId);
      });
    },
    isSameRoute(targetRoute) {
      const resolved = this.$router.resolve(targetRoute).route;

      return (
        resolved.path === this.$route.path &&
        JSON.stringify(resolved.query || {}) ===
          JSON.stringify(this.$route.query || {})
      );
    },
  },
};
</script>
<style scoped>
.mob-bottom-nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: -1px;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  height: calc(80px + env(safe-area-inset-bottom));
  background: #ffffff;
  border-top: 1px solid #efefef;
  z-index: 1050;
}

.mob-bottom-nav .nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 4px;
}

.mob-bottom-nav .nav-item span {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #7e808f;
}

.mob-bottom-nav .nav-item.active span {
  color: #4A7EFF;
  font-weight: 700;
}

.mob-bottom-nav .nav-item img {
  height: 32px;
  width: auto;
}

.mob-bottom-nav .nav-icon-container {
  position: relative;
  display: flex;
}

.mob-bottom-nav .nav-icon-container .notif-dot {
  position: absolute;
  top: 1.35px;
  right: 0px;
  height: 6.78px !important;
  width: 6.78px !important;
  z-index: 2;
}

.mob-bottom-nav .mob-avatar {
  width: 26.71px;
  height: 26.71px;
  border-radius: 50%;
  background-color: #4A7EFF;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Lato", sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.mob-bottom-nav .mob-avatar span {
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 1;
}

.mob-bottom-nav .nav-separator {
  width: 1px;
  height: 36px;
  background-color: #8C8C8C4D;
  align-self: center;
}

@media (min-width: 1028px) {
  .mob-bottom-nav {
    display: none;
  }
}
</style>
